var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Privacy & Communication")]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("div", { staticClass: "checkbox checkbox-primary" }, [
                  _c("div", { staticClass: "input-group-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.optedIn,
                          expression: "optedIn",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "ff-marketing-opt-in",
                        name: "marketingOptIn",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.optedIn)
                          ? _vm._i(_vm.optedIn, null) > -1
                          : _vm.optedIn,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.optedIn,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.optedIn = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.optedIn = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.optedIn = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ff-marketing-opt-in" } }, [
                      _vm._v(
                        "\n                  I wish to receive news and marketing material from " +
                          _vm._s(_vm.clientName) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary pull-right margin-y-1",
                    attrs: {
                      button: "",
                      click: _vm.handleSavePrivacyDataCallback,
                      disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
                    },
                  },
                  [_vm._v("\n              Save\n            ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-t-xl" }, [
      _c("p", [
        _vm._v(
          "If you would like to request a copy of your data, or request the removal of your data on our platform, please write to us at "
        ),
        _c("a", { attrs: { href: `mailto:${this.$privacyEmail}` } }, [
          _vm._v(_vm._s(this.$privacyEmail)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }